import React from "react";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import logo from "../../assets/svgs/avatr/avatr-wordmark.svg";

interface LoadingComponentProps {
  isPortrait: boolean;
  progress: number;
  showLoading: boolean;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ isPortrait, progress, showLoading }) => {

  const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 2,
    borderRadius: 0,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      height: 2,
      borderRadius: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.14)',
    },
    [`& .${linearProgressClasses.bar}`]: {
      height: 2,
      borderRadius: 0,
      background: '#FBFBFB',
      boxShadow: '0 0 12px rgba(180, 215, 25, 0.9)',
    },
  }));

  return (
    <div className={`loading-container ${showLoading ? '':'hide-container'}`}>
      <div className={`loading-progress ${isPortrait ? 'portrait':''}`}>
        <img className={`loading-post-logo ${isPortrait ? 'portrait':''}`} src={logo} alt="" />
        <div className={`loading-progress-bar ${isPortrait ? 'portrait':''}`}>
          <Box sx={{ width: '100%', height: '100%' }}>
            <BorderLinearProgress variant="determinate" value={progress} />
          </Box>
        </div>
        <div className={`loading-progress-info ${isPortrait ? 'portrait':''}`}>
          <div className={`loading-progress-message ${isPortrait ? 'portrait':''}`}>
            La experiencia está iniciando, por favor espera
          </div>
          <div className={`loading-progress-value`}>{`${Math.round(progress)}%`}</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingComponent;